/* index.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./index.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { Drawer, DrawerContent } from '@atlaskit/drawer/compiled';
import { AdminhubIntlProvider } from '../../common/utils/locale';
import { Content } from './content';
import { Footer } from './footer';
import { Header } from './header';
import { ContentWrapper, DrawerContainer, DrawerWrapper, ParentContentWrapper } from './styled';
const styles = {
  drawerContent: "_19pkze3t"
};
const FocusedTaskImpl = ({
  testId = 'focused-task',
  currentStep,
  isOpen,
  steps,
  onClose,
  onCloseComplete,
  onOpenComplete,
  headerRightContent,
  rightContent,
  zIndex,
  ariaLabel,
  titleId
}) => {
  const currentStepConfig = steps[currentStep];
  const {
    content,
    isSubmissionLoading,
    isFetchLoading,
    errorContent,
    hasError,
    formId,
    backButtonOnClick,
    nextButtonOnClick,
    type
  } = currentStepConfig;
  const handleDrawerOnClose = () => {
    onClose && onClose();
  };
  const shouldShowHeader = type === 'progress';
  const shouldShowFooter = !hasError && !isFetchLoading && (!!backButtonOnClick || !!nextButtonOnClick || !!formId);
  const contentSize = currentStepConfig.contentSize || 'medium';
  return /*#__PURE__*/React.createElement(Drawer, {
    testId: testId,
    zIndex: zIndex,
    width: "full",
    isOpen: isOpen,
    onClose: () => handleDrawerOnClose(),
    onOpenComplete: onOpenComplete,
    onCloseComplete: onCloseComplete,
    label: ariaLabel,
    titleId: titleId
  }, /*#__PURE__*/React.createElement(DrawerContent, {
    xcss: styles.drawerContent
  }, /*#__PURE__*/React.createElement(DrawerContainer, null, /*#__PURE__*/React.createElement(DrawerWrapper, null, /*#__PURE__*/React.createElement(Header, {
    testId: testId,
    steps: steps,
    currentStep: currentStep,
    shouldShowHeader: shouldShowHeader,
    handleDrawerOnClose: handleDrawerOnClose,
    headerRightContent: headerRightContent
  }), /*#__PURE__*/React.createElement(ParentContentWrapper, null, /*#__PURE__*/React.createElement(ContentWrapper, {
    "data-testid": `${testId}-content`,
    contentSize: contentSize
  }, /*#__PURE__*/React.createElement(Content, {
    isFetchLoading: isFetchLoading,
    hasError: hasError,
    isSubmissionLoading: isSubmissionLoading,
    content: content,
    errorContent: errorContent,
    testId: testId
  }))), shouldShowFooter && /*#__PURE__*/React.createElement(Footer, {
    contentSize: contentSize,
    currentStepConfig: currentStepConfig,
    testId: testId,
    currentStep: currentStep
  })), rightContent)));
};
export const FocusedTask = props => /*#__PURE__*/React.createElement(AdminhubIntlProvider, null, /*#__PURE__*/React.createElement(FocusedTaskImpl, props));
export default FocusedTask;